import { render, staticRenderFns } from "./RecordTypeRestoreContainer.vue?vue&type=template&id=464914f6"
import script from "./RecordTypeRestoreContainer.vue?vue&type=script&lang=js"
export * from "./RecordTypeRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports